/**
 * @generated SignedSource<<0ad49c2d2e931239b7c0c1515ee3ff64>>
 * @relayHash 661be1aed012c73ddf57359bb2f0fd03
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 444ca279fa290fc5e4ffd44221107b411b77e5d0204ea16d406462977970c79a

import type { ConcreteRequest } from 'relay-runtime';
export type useGetSpaceIdsFromSpaceKeysQuery$variables = {
  spaceKeys?: ReadonlyArray<string | null> | null;
};
export type useGetSpaceIdsFromSpaceKeysQuery$data = {
  readonly spaces: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
    } | null> | null;
  } | null;
};
export type useGetSpaceIdsFromSpaceKeysQuery = {
  response: useGetSpaceIdsFromSpaceKeysQuery$data;
  variables: useGetSpaceIdsFromSpaceKeysQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKeys"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKeys",
        "variableName": "spaceKeys"
      }
    ],
    "concreteType": "PaginatedSpaceList",
    "kind": "LinkedField",
    "name": "spaces",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useGetSpaceIdsFromSpaceKeysQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetSpaceIdsFromSpaceKeysQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "661be1aed012c73ddf57359bb2f0fd03",
    "id": "444ca279fa290fc5e4ffd44221107b411b77e5d0204ea16d406462977970c79a",
    "metadata": {},
    "name": "useGetSpaceIdsFromSpaceKeysQuery",
    "operationKind": "query",
    "text": "query useGetSpaceIdsFromSpaceKeysQuery($spaceKeys:[String]){spaces(spaceKeys:$spaceKeys){nodes{id}}}"
  }
};
})();

(node as any).hash = "9ccf9d7ef02a43c85929f80101c907a1";

export default node;
